export const formatElectoralState = (stato: string): string | undefined => {
  switch (stato) {
    case 'E':
      return 'Elettore';
    case 'I':
      return 'Iscrivendo';
    case 'C':
      return 'Cancellando';
    case 'V':
      return 'Variando';
    case 'A':
      return 'Archiviato';
    case 'N':
      return 'Non iscritto';
    case 'S':
      return 'Straniero';
    default:
      return undefined;
  }
};
